import { createTypes, createAction } from "lib/action";
import { storeCredentials, removeCredentials } from "modules/auth/actions";

const CHECK_OAUTH_LOGIN = createTypes("oauth", "check");

const checkOauthLogin = {
  request: payload => createAction(CHECK_OAUTH_LOGIN.REQUEST, { payload }),
  success: (
    token,
    tokenPayload,
    permissions,
    vehicle_list,
    location_list,
    vehicle_group_list,
    divisions,
    departments,
    sections,
  ) =>
    createAction(CHECK_OAUTH_LOGIN.SUCCESS, {
      token,
      tokenPayload,
      permissions,
      vehicle_list,
      location_list,
      vehicle_group_list,
      divisions,
      departments,
      sections,
    }),
  failure: (status, msg) =>
    createAction(CHECK_OAUTH_LOGIN.FAILURE, { status, msg }),
};

export {
  CHECK_OAUTH_LOGIN,
  checkOauthLogin,
  storeCredentials,
  removeCredentials,
};
